import { render } from "./Frizer.vue?vue&type=template&id=03854e1a&scoped=true"
import script from "./Frizer.vue?vue&type=script&lang=js"
export * from "./Frizer.vue?vue&type=script&lang=js"

import "./Frizer.vue?vue&type=style&index=0&id=03854e1a&scoped=true&lang=css"
import "./Frizer.vue?vue&type=style&index=1&id=03854e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03854e1a"]])

export default __exports__